var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarMini = function SvgStarMini(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.988 1.37c.72-1.826 3.304-1.826 4.024 0l.396 1.004c.22.557.661.998 1.218 1.218l1.005.396c1.825.72 1.825 3.304 0 4.024l-1.005.396c-.557.22-.998.661-1.218 1.218l-.396 1.005c-.72 1.825-3.304 1.825-4.024 0l-.396-1.005a2.16 2.16 0 0 0-1.218-1.218l-1.005-.396c-1.825-.72-1.825-3.304 0-4.024l1.005-.396c.557-.22.998-.661 1.218-1.218z"
  })));
};
export default SvgStarMini;